import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { bindActionCreators } from 'redux';
import global_axios from '../../funciones_globales/interaccionapi';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import { Row } from '../componentes_generales/componentes_formulario/contenedores/';
import { cargarCatalogosGenericoAsyncInvertido } from '../../funciones_globales/catalogos';
import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { seleccionar_CuentaContable, cargar_indicadorCCosto } from '../../actions/contabilidad/act_busquedaCtaContable';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';

const Button = styled.button`
  height: 27px;
  line-height: 10px;
`;

const ButtonModal = styled.button`
  height: 25px;
  line-height: 10px;
`;

const ModalContainer = styled.div`
  margin-top: 20px;
  height: 400px;
  width: 410px;
`;

const Hr = styled.hr`
  margin-top: 10px;
  margin-bottom: 10px;
`;

const PaginationLabels = styled.div`
    font-size: 12px;
`;

const PaginationButtons = styled.div`
    margin-bottom:10px;
`;

class BusquedaCtaContable extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            isModalVisible: false,
            cuenta: '',
            cuentasContables: [],
            pagination: {
                totalFilas: 0,
                totalFilasPorPagina: 0,
                primeraFilaPagina: 0,
                ultimaFilaPagina: 0,
            },
            columnDefs: [
                {   header: "No.",
                    field: "NroItem",
                    width: 40,
                    type: "string",
                    suppressFilter: true
                },
                {   header: "Cuenta",
                    field: "Codigo",
                    width: 100,
                    type: "string"
                },
                {   header: "Nombre Cuenta",
                    field: "Descripcion",
                    width: 268,
                    type: "string"
                }
              ],
        };

        this.gridCuentasContables = {
            enableColResize: true,
            enableSorting: true,
            enableFilter: false,
            rowSelection: "single",
            paginationAutoPageSize:true,
            pagination: true,
            suppressPaginationPanel: true,
            suppressScrollOnNewData: true,
            onPaginationChanged: () => {
                if(!this.gridCuentasContablesApi){
                    return;
                }
                let totalFilas = this.gridCuentasContablesApi.paginationGetRowCount();
                let totalFilasPorPagina = this.gridCuentasContablesApi.paginationGetPageSize();
                let ultimaFilaPagina = (totalFilasPorPagina * (this.gridCuentasContablesApi.paginationGetCurrentPage()+1));
                let indexPage = this.gridCuentasContablesApi.paginationGetCurrentPage();

                if( ultimaFilaPagina >  totalFilas){
                    ultimaFilaPagina = totalFilas;
                }
                let pagination = {
                    totalFilas: totalFilas,
                    totalFilasPorPagina: totalFilasPorPagina,
                    primeraFilaPagina: (totalFilasPorPagina * (indexPage + 1) - totalFilasPorPagina + 1),
                    ultimaFilaPagina: ultimaFilaPagina
                };

                this.setState({pagination});
            },
            onRowDoubleClicked: (event) => {
                this.seleccionarCuentaContable();
            }
        };

        this.getOptions_CtaContable = this.getOptions_CtaContable.bind(this);
        this.onGridReady = this.onGridReady.bind(this);
        this.getCuentasContables = this.getCuentasContables.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.seleccionarCuentaContable = this.seleccionarCuentaContable.bind(this);
        this.getCContableById = this.getCContableById.bind(this);
    }

    onGridReady(params) {
        this.gridCuentasContablesApi = params.api;
        this.gridCuentasContablesColumnApi = params.columnApi;
    }

    getOptions_CtaContable(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '?cadena_busq=' + input +'&plan='+ this.props.planVigente;
            cargarCatalogosGenericoAsyncInvertido('/cuentas', cadena_busq, callback)
        }
    }

    getCuentasContables(){
        if( this.state.cuenta.toString().trim() === "" ){
            alert("Ingrese la cuenta contable a buscar");
            return;
        }
        this.props.cambiar_VisualizacionLoading(true);

        let cadena_busq = "?cadena_busq=" + this.state.cuenta + "&plan=" + this.props.planVigente+"&unlimit=1";
        global_axios({
            method: 'GET',
            url: '/cuentas/' + cadena_busq
        })
        .then( response => {
            if( !response.data.length ){
                this.props.cambiar_VisualizacionLoading(false);
                this.setState({cuentasContables:[]})
                alert("No se encontraron datos");
                return;
            }
            
            let asientos = [];
            response.data.forEach((item, i) => {
                asientos.push({
                    ...item,
                    NroItem: (i+1)
                });
            });

            this.setState({cuentasContables: asientos});
            this.props.cambiar_VisualizacionLoading(false);
        })
        .catch( error => {
            this.props.cambiar_VisualizacionLoading(false);
            alert("Ha ocurrido un error: " + error);
        });
    }

    getCContableById(cuenta){
        if( cuenta !== undefined && cuenta !== null){
            global_axios({
                method: 'GET',
                url: '/cuentas/' + cuenta.value + '/' + this.props.planVigente
            })
            .then( response => {
                let ccontable = response.data;
                this.props.cargar_indicadorCCosto(ccontable.IndicadorCCosto);

                if( this.props.onChangeCallback ){
                    this.props.onChangeCallback();
                }
            })
            .catch( error => {
                alert("Ha ocurrido un error: " + error);
            });
        }else{
            this.props.cargar_indicadorCCosto("0");
        }
    }

    seleccionarCuentaContable(){
        let cuentaContableSel = this.gridCuentasContablesApi.getSelectedRows();
        
        if( !cuentaContableSel.length ){
            alert("Debe de seleccionar una cuenta contable");
            return;
        }

        let cc = cuentaContableSel[0];
        this.props.seleccionar_CuentaContable({key:this.props.id, cuenta:{
            value: cc.Codigo,
            label: cc.Codigo + " (" +cc.Descripcion.toUpperCase() + ")"}
        });
        
        this.setState({isModalVisible: false});
        
        this.getCContableById({"value": cc.Codigo});
    }

    handleInputChange(event){    
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({
            [name]: value
        });
    }

    render(){
        return(
            <div>
                <div className="input-group">
                    <ReactSelectAsync value={this.props.cuentasContables_sel[this.props.id]===undefined?null:(this.props.cuentasContables_sel[this.props.id]===null?null:this.props.cuentasContables_sel[this.props.id].cuenta)}
                        func_loadOptions={this.getOptions_CtaContable} func_onChange={(value)=>{ if(Array.isArray(value)){value=null;} this.props.seleccionar_CuentaContable({key:this.props.id, cuenta: value}); this.getCContableById(value)}} />
                    <span className="input-group-btn">
                        <Button type="button" className="btn btn-default btn-sm" onClick={() => {this.setState({isModalVisible: true})}}>...</Button>
                    </span>
                </div>
                <ModalResponsive open={this.state.isModalVisible} onClose={()=>{this.setState({isModalVisible:false})}}>
                    <ModalContainer>
                        <Row>
                            <div className='col-sm-12'>
                                <h4>Búsqueda de cuentas contables</h4>
                                <Hr/>
                            </div>
                        </Row>
                        <Row>
                            <div className="col-sm-12">
                                <small>
                                    <span>Plan Vigente: </span>
                                    <label>{this.props.planVigente}</label>
                                </small>
                            </div>
                        </Row>
                        <Row>
                            <div className="col-sm-12">
                                <div className="input-group">
                                    <InputText placeholder="Busqueda de cuentas contables" name="cuenta" value={this.state.cuenta} onChange={this.handleInputChange} />
                                    <span className="input-group-btn">
                                        <ButtonModal type="button" className="btn btn-primary btn-sm" onClick={this.getCuentasContables}>
                                            <i className="fa fa-search"></i>
                                        </ButtonModal>
                                    </span>
                                </div>
                            </div>
                        </Row>
                        <Row>
                            <div className="col-sm-12">
                                <AgGridRender
                                    altura='330px'
                                    data={this.state.cuentasContables}
                                    columnas={this.state.columnDefs}
                                    onGridReady={this.onGridReady}
                                    gridOptions={this.gridCuentasContables}
                                />
                            </div>
                        </Row>

                        <Row>
                            <div className="col-sm-12">
                                <PaginationLabels>
                                    {this.state.pagination.primeraFilaPagina} a {this.state.pagination.ultimaFilaPagina} de {this.state.pagination.totalFilas}
                                </PaginationLabels>
                                <PaginationButtons>
                                    <div className="btn-group btn-group-xs" role="group">
                                        <button className="btn btn-default" onClick={() => this.gridCuentasContablesApi.paginationGoToFirstPage()}>
                                            <i className="fa fa-angle-double-left fa-fw"></i>Ir al inicio
                                        </button>
                                        <button className="btn btn-default" onClick={() => this.gridCuentasContablesApi.paginationGoToPreviousPage()}>
                                            <i className="fa fa-angle-left fa-fw"></i>Anterior
                                        </button>
                                        <button className="btn btn-default" onClick={() => this.gridCuentasContablesApi.paginationGoToNextPage()}>
                                            Siguiente<i className="fa fa-angle-right fa-fw"></i>
                                        </button>
                                        <button className="btn btn-default" onClick={() => this.gridCuentasContablesApi.paginationGoToLastPage()}>
                                            Ir al final<i className="fa fa-angle-double-right fa-fw"></i>
                                        </button>
                                    </div>
                                </PaginationButtons>
                            </div>
                        </Row>
                        <Row>
                            <div className='col-sm-12'>
                                <div className="btn-group pull-right">
                                    <button type='button' className='btn btn-primary btn-sm' onClick={this.seleccionarCuentaContable}><i className='fa fa-check fa-lg'></i> Seleccionar</button>                    
                                    <button type='button' className='btn btn-danger btn-sm' onClick={() => this.setState({isModalVisible: false})}><i className='fa fa-times-circle fa-lg'></i> Cerrar</button>                                                
                                </div>
                            </div>
                        </Row>                     
                    </ModalContainer>
                </ModalResponsive>
            </div>
        );
    }
}

const mapStateToProps = ((state) => {
    return {
      cuentasContables_sel: state.contabilidad.cuentasContables_sel,
      indicadorCCosto: state.contabilidad.indicadorCCosto,
    };
  });
  
  const mapDispatchToProps = ((dispatch) => {
    return bindActionCreators({
      cambiar_VisualizacionLoading, seleccionar_CuentaContable, cargar_indicadorCCosto
    }, dispatch);
  });
  
  export default connect (mapStateToProps, mapDispatchToProps)(BusquedaCtaContable);